export default "__VITE_ASSET__CAHrb7mQ__"